import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#00A896] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4 font-['Playfair_Display']">
              Conte Assessoria Contábil
            </h3>
            <p className="text-white/90 mb-6 leading-relaxed">
              Há mais de 18 anos oferecendo soluções completas em contabilidade, 
              planejamento tributário e consultoria empresarial para empresas em Curitiba e região.
            </p>
            <div className="flex items-center space-x-4">
              <div className="text-[#1A3A52] font-semibold">CRC/PR 047.892</div>
              <div className="w-1 h-1 bg-white/60 rounded-full"></div>
              <div className="text-white/90">Marcos Henrique Conte</div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('sobre');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('servicos');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('diferenciais');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Diferenciais
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('contato');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Contato
                </button>
              </li>
              <li>
                <a 
                  href="#area-cliente" 
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Área do Cliente
                </a>
              </li>
              <li>
                <a 
                  href="#politica-privacidade" 
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-[#1A3A52]"></i>
                <a 
                  href="tel:+554132257788"
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  (41) 3225-7788
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line mr-3 text-[#1A3A52]"></i>
                <a 
                  href="https://wa.me/5541996543210"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  (41) 99654-3210
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-[#1A3A52]"></i>
                <a 
                  href="mailto:contato@contecontabil.com.br"
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  contato@contecontabil.com.br
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h5 className="text-sm font-semibold mb-3">Redes Sociais</h5>
              <div className="flex space-x-4">
                <a 
                  href="https://linkedin.com/company/conte-assessoria"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#0077B5] rounded-full flex items-center justify-center hover:bg-[#005885] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-white"></i>
                </a>
                <a 
                  href="https://instagram.com/conteassessoria"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center hover:from-purple-600 hover:to-pink-600 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a 
                  href="https://wa.me/5541996543210"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center hover:bg-[#20B858] transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="text-center">
            <div className="text-white/90 text-sm">
              © 2025 Conte Assessoria Contábil - Todos os direitos reservados
            </div>
            <div className="text-white/80 text-xs mt-2">
              CRC/PR 047.892 – Marcos Henrique Conte, Contador Responsável
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
